




























































































import { isEmpty, isNull } from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { inject } from 'inversify-props'
import API from '@core/services/API'
import { AccountStructureMemberService, CommissionRecordsService, ReportGeneratorDto } from '../../api'
import AccountMetaList from '@core/pages/account/model/AccountMetaList'
import { PayeeMetaList } from '@core/model/common/PayeeMetaList'
import { PayeeMetaHeaders } from '@core/model/common/PayeeMeta'
import AppDialog from '@core/components/AppDialog.vue'

@Component({
  components: {
    AppDialog
  }
})
export default class ReportGenerator extends Vue {
  @inject()
  private $api: API

  private reportType: number = null
  private resultOption: string = null
  private from = ''
  private to = ''
  private status: ReportGeneratorDto.status = null
  private generatingReport = false
  private ifamList: AccountMetaList = null
  private payeeList: PayeeMetaList = null
  private principal = []
  private showSearchUserModal = false
  private searchUser = ''

  get reportTypeOptions () {
    return [
      {
        value: 0,
        label: 'Statement of Remuneration'
      },
      {
        value: 1,
        label: 'Revenue Summary (Sort by Type)'
      },
      {
        value: 2,
        label: 'Revenue Summary (Sort by Principal)'
      },
      {
        value: 3,
        label: 'Production Report'
      },
      {
        value: 4,
        label: 'Introducer Report'
      },
      {
        value: 5,
        label: 'Vesting Report'
      },
      {
        value: 6,
        label: 'Servicing Report'
      }
    ]
  }

  get options () {
    if (this.reportType === 2) {
      const opts = []
      this.principal.forEach(p => opts.push({ oid: [p], name: p }))
      if (opts.length !== 0) opts.unshift({ oid: this.principal, name: 'All' })
      return opts
    } else {
      return this.allUsersOptions
    }
  }

  get filteredUsers () {
    return this.allUsersOptions.filter(e => e.name.toLowerCase().includes(this.searchUser.toLowerCase())).sort((current, compare) => {
      if (current.name === compare.name) return 0
      return current.name > compare.name ? 1 : -1
    })
  }

  get allUsersOptions () {
    let users: Array<{ oid: string; name: string }> = this.ifamList?.getFullList().map(e => ({ oid: e.oid, name: e.fullname || e.names[0] })) || []

    if (this.reportType === 4 || this.reportType === 5) {
      users = [
        ...users,
        ...this.payeeList?.getFullList().map(e => ({ oid: e.oid, name: e.payeeFullname })) || []
      ]
    }

    if (this.reportType === 1 || this.reportType > 3) {
      users.unshift({ oid: null, name: 'All' })
    }

    return users
  }

  get statusOptions () {
    return [
      {
        value: 'paid',
        label: 'Paid'
      },
      {
        value: 'unpaid',
        label: 'Unpaid'
      }
    ]
  }

  openSearchUser () {
    if (this.reportType !== 2) {
      this.showSearchUserModal = true
    }
  }

  async selectUser (user: { oid: string; name: string }) {
    if (this.reportType === 0 || this.reportType === 3) {
      const structurePath = await AccountStructureMemberService.findMemberInStructure(user.oid)
      alert(`User: ${user.name} in ${structurePath.join('/')}`)
    }
    this.resultOption = user.oid
    this.showSearchUserModal = false
  }

  async generateReport () {
    if (isNull(this.reportType) || isEmpty(this.from) || isEmpty(this.to) || isEmpty(this.status)) {
      alert('Please fill in all input')
      return
    }

    const from = new Date(this.from).getTime()
    const to = new Date(this.to).getTime()

    try {
      this.generatingReport = true
      const res = await CommissionRecordsService.reportGenerator({
        report: this.reportType,
        option: this.resultOption,
        from,
        to,
        status: this.status
      })

      const link = document.createElement('a')
      link.href = this.base64ToBlob(res.data)
      link.download = 'Report.pdf'
      link.click()
      link.remove()
    } catch (error) {
      alert(error.body.message)
    }
    this.generatingReport = false
  }

  async fetchIfamUserList () {
    const headers = [
      '_oid',
      'fullname',
      'names'
    ]

    const res = await this.$api.account.list({
      headers: JSON.stringify(headers)
    })
    this.ifamList = new AccountMetaList(headers, res.data)
  }

  async fetchPayeeList () {
    const res = await this.$api.intermediaries.list({
      headers: JSON.stringify(PayeeMetaHeaders)
    })
    this.payeeList = new PayeeMetaList(res.data)
  }

  base64ToBlob (b64Data: string, type = 'application/pdf'): string {
    const byteCharacters = atob(b64Data)
    const byteArrays = []
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512)
      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }
    const blob = new Blob(byteArrays, { type })
    return URL.createObjectURL(blob)
  }

  @Watch('reportType')
  reportTypeChange () {
    this.resultOption = null
  }

  closeModal () {
    this.showSearchUserModal = false
    this.searchUser = ''
  }

  async mounted () {
    const {
      principal
    } = await this.$api.commissionRecordsRel.getUsersAndPrincipals()
    this.principal = principal
    await this.fetchIfamUserList()
    await this.fetchPayeeList()
  }
}
